<div class="navigation k-grid-pager" [class.disabled]="disabled()">
  <button
    kendoButton
    fillMode="flat"
    (click)="goPrevPage()"
    [disabled]="isPrevDisabled()"
    class="k-pager-nav"
    iconClass="fa fa-angle-left"
  ></button>

  <div class="pager-input">
    <div class="k-pager-input">
      <kendo-numerictextbox
        [value]="page()"
        (keydown)="onPageInputKeydown($event)"
        [min]="1"
        [max]="totalPages()"
        [step]="1"
        [format]="'N0'"
        [spinners]="false"
        class="k-pager-input-textbox"
      ></kendo-numerictextbox>
    </div>
    <span class="of-text">of</span>
    <span class="total-number">{{ totalPages() }}</span>
  </div>

  <button
    kendoButton
    fillMode="flat"
    (click)="goNextPage()"
    [disabled]="isNextDisabled()"
    class="k-pager-nav"
    iconClass="fa fa-angle-right"
  ></button>
</div>
